import { render, staticRenderFns } from "./SmbTable.vue?vue&type=template&id=206503a8&scoped=true&"
import script from "./SmbTable.vue?vue&type=script&lang=ts&"
export * from "./SmbTable.vue?vue&type=script&lang=ts&"
import style0 from "./SmbTable.scss?vue&type=style&index=0&id=206503a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206503a8",
  null
  
)

export default component.exports